// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import { isRunningOnChromeCastDevice } from 'Common/cast/CastUtils';

import './index.css';
import App from './App';

const renderApp = () => ReactDOM.render(<App />, document.getElementById('app_root'));

const logAppVersion = () => console.log(`RECEIVER APP VERSION: v${process.env.VERSION}`);

const renderFallback = () => {
  document.querySelector('#splash_preload').remove();

  ReactDOM.render(
    <div className="App">
      <header className="App-header">
        <p>The app runs only on Chromecast devices.</p>
      </header>
    </div>,
    document.getElementById('app_root'),
  );
};

if (isRunningOnChromeCastDevice() || process.env.IN_DEBUG) {
  renderApp();
  logAppVersion();
} else {
  renderFallback();
}
